/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export enum FolderStatusCodes {
    DOC_UPLOAD = 1,
    DOC_MOVE_IN = 1,
    DOC_MOVE = 2,
    DOC_RENAME = 4,
    DOC_DELETE = 8,
    FOLDER_RENAME = 16,
    FOLDER_MOVE = 32,
    FOLDER_DELETE = 64,
    SUB_FOLDER_CREATE = 128,
    SUB_FOLDER_MOVE_IN = 128,
    LINK_CREATE = 256
}

export enum FolderTypeCodes {
    ROOT = "ROOT",
    SYSTEM = "SYSTEM",
    ENTERPRISE = "ENTERPRISE",
    ENTERPRISE_TEAMS = "ENTERPRISE_TEAMS",
    SYSTEM_SUBJECT = "SYSTEM_SUBJECT",
    SUBJECT = "SUBJECT",
    PERSONAL = "PERSONAL",
    SHORT_CUT = "SHORT_CUT",
    RESOURCE_LIBRARY = "RESOURCE_LIBRARY",
    RESOURCE_LIBRARY_CHILD = "RESOURCE_LIBRARY_CHILD"
}

export class DocumentFolder implements Serializable<DocumentFolder> {

    id: number;
    name: string;
    parentId: number;
    folderType: string;
    documentType: string;
    userId: number;
    icon: string;
    createdAt: any;
    updatedAt: any;
    allowedOperation = 255;
    subjectId;
    color;
    childCount: number;
    message: string;
    orgId: number;
    parentIds;

    deserialize(input) {

        input.id && (this.id = input.id);
        input.name && (this.name = input.name);
        this.parentId = input.parentId;
        input.folderType && (this.folderType = input.folderType);
        input.documentType && (this.documentType = input.documentType);
        input.userId && (this.userId = input.userId);
        input.icon && (this.icon = input.icon);
        input.color && (this.color = input.color);
        input.createdAt && (this.createdAt = new Date(input.createdAt));
        input.updatedAt && (this.updatedAt = new Date(input.updatedAt));
        this.allowedOperation = input.allowedOperation;
        input.subjectId && (this.subjectId = input.subjectId);
        this.childCount = input.childCount;
        this.orgId = input.orgId;
        this.parentIds = input.parentIds;
        input.message && (this.message = input.message);


        return this;
    }

    constructor() {
    }


}
